import { Quadkey } from '../../../../Quadkey'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const quadkeysFromMinterEvent = (event: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const quadkeyObjs: any[] = []

  quadkeyObjs.push(event.args['id'])
  quadkeyObjs.push(event.args['to'])
  quadkeyObjs.push(event.args['from'])

  return quadkeyObjs
    .filter((qk) => {
      return qk !== undefined && qk.toHexString !== undefined
    })
    .map((quadkeyObj) => {
      return Quadkey.fromBase16String(quadkeyObj.toHexString())
    })
}
